import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f68f044"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f68f044')) {
      api.createRecord('3f68f044', component.options)
    } else {
      api.reload('3f68f044', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3f68f044", function () {
      api.rerender('3f68f044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/echarts/chart/pie/base/IkPieBaseChart/index.vue"
export default component.exports